import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorC1ByHealthTeamParams = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export class ResumeIndicatorC1ByHealthTeamData {
	attendanceHealthTeamId: number = 0;
	attendanceHealthTeamName?: string;
	attendanceHealthTeamIne?: string;
	totalAttendances: number = 0;
	totalScheduledAttendances: number = 0;
}

export async function getResumeIndicatorC1ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorC1ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorC1ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c1/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorC1ByHealthTeamData>();
}
